"use strict";
// Based on https://github.com/tautcony/webvtt2ass
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseToTranscription = exports.generateAss = exports.snippetTranscription = void 0;
var parser_1 = __importDefault(require("webvtt/lib/parser"));
var subtitle_text_1 = __importDefault(require("./subtitle.text"));
var subtitle_1 = require("subtitle");
var uuid_1 = require("uuid");
var validation_1 = require("./validation");
exports.snippetTranscription = function (transcription, snippet) {
    var start = snippet.start, end = snippet.end;
    var duration = end - start;
    /*
      Here is a little visual diagram of different conditions.
       start       end
      [==|==]       |         Out-In:  t.start <= start && t.end >= start
         |  [====]  |         In-In:   t.start >= start && t.end <= end
         |       [==|==]      In-Out:  t.start <= end   && t.end >= end
      [==|==========|==]      Out-Out: t.start <= start && t.end >= end
         |          |
    */
    return transcription
        .filter(function (t) {
        return (t.start <= start && t.end >= start) ||
            (t.start >= start && t.end <= end) ||
            (t.start <= end && t.end >= end) ||
            (t.start <= start && t.end >= end);
    })
        .map(function (t) {
        t.start = t.start - start;
        t.end = t.end - start;
        if (t.start < 0) {
            t.start = 0;
        }
        if (t.end > duration) {
            t.end = duration;
        }
        return t;
    });
};
exports.generateAss = function (transcription, config, snippet) {
    if (snippet) {
        transcription = exports.snippetTranscription(transcription, snippet);
    }
    var vtt = subtitle_1.stringify(transcription, { format: "vtt" });
    return vttToAss(vtt, config);
};
function vttToAss(input, config) {
    var _a, _b, _c;
    var output = [subtitle_text_1.default.assHeader(config)];
    if ((_a = config.headline) === null || _a === void 0 ? void 0 : _a.visible) {
        var _d = config.headline, duration = _d.duration, text = _d.text;
        var end = new Date(+(duration || 5000)).toISOString().substr(11, 8);
        var formatText = (_b = text === null || text === void 0 ? void 0 : text.replace(/\n/g, "\\N")) !== null && _b !== void 0 ? _b : "";
        output.push("Dialogue: 3,00:00:00.00," + end + ".00,Title,,0,0,0,," + formatText + "\n");
    }
    new parser_1.default.WebVTTParser()
        .parse(input, "subtitles")
        .cues.forEach(function (item) {
        var ret = subtitle_text_1.default.parseSegment(item);
        output.push("Dialogue: 1," + ret.begin + "," + ret.end + "," + ret.style + "," + ret.voice + ",0,0,0,," + ret.text + "\n");
    });
    if ((_c = config.customLogo) === null || _c === void 0 ? void 0 : _c.visible) {
        output.push("Comment: 0,00:00:00.00,00:00:00.00,Title,,0,0,0,," + JSON.stringify(config.customLogo) + "\n");
    }
    return output.join("");
}
exports.parseToTranscription = function (text) {
    try {
        var nodes = subtitle_1.parse(text);
        var transcription = nodes.map(function (_a) {
            var start = _a.start, end = _a.end, text = _a.text;
            return {
                id: uuid_1.v4(),
                start: start,
                end: end,
                text: text
            };
        });
        return validation_1.validateTranscription(transcription);
    }
    catch (error) {
        return undefined;
    }
};
//# sourceMappingURL=index.js.map